import CustomIcon from "../../components/CustomIcon";
import * as React from "react";
import {
  Text,
  View,
  Image,
  TouchableOpacity,
  StyleSheet,
  Dimensions,
  Platform,
} from "react-native";
import { ScrollView, TextInput } from "react-native-gesture-handler";
import { useNavigation } from "@react-navigation/native";
import GlobalStyles from "../../components/GlobalStyles";
import { useSelector } from "react-redux";
import axios from "axios";
import getEnvVars from "../../enviroment";
import { Auth } from "aws-amplify";
import { enableDebugMode, disableDebugMode } from "../../redux/actions/UIStateActions";
import { user_force_refresh } from "../../redux/actions/UserActions";
import { reffererIdToCharityId } from "../../redux/actions/UserActions";
import AsyncStorage from "@react-native-async-storage/async-storage";

async function removeSavedLogin() {
  const savedLogin = {
    mode: 'null'
  }
  await AsyncStorage.setItem('loginMemory', JSON.stringify(savedLogin));
}

function removeShell(memberId, refId) {
    
const baseURL = getEnvVars().apiUrl;


    Auth.currentSession().then( (cognitoUserSession) => {
        var axi = axios.create({
          baseURL: baseURL,
          withCredentials: false,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Authorization": cognitoUserSession.getIdToken().getJwtToken()
          }
        });

        var data = {
                       "memberId":memberId,
                       "partnerName":"Shell",
                       "partner_id":refId,
                       "partnerStatus": "inactive",
                            "payload":
                            {
                                 "partner_custom_field_A":"", 
                                 "partner_custom_field_B":"", 
                                 "partner_custom_field_C":"", 
                                  "partner_custom_field_D":"", 
                                 "partner_custom_field_E":"", 
                                 "partner_custom_field_F":"", 
                                 "partner_custom_field_G":"", 
                                 "partner_custom_field_H":"", 
                                 "partner_custom_field_I":"", 
                                 "partner_custom_field_J":""
                            }
            }
            axi.post('/partners/update', data).then(function (response) {
              if (response.data === null || response.status !== 200){
                // presumed error
                user_force_refresh();
                return;
              } else {
                user_force_refresh();
              }
            });
    

    });
}

function reenableShell(memberId, refId) {
    
    const baseURL = getEnvVars().apiUrl;


        Auth.currentSession().then( (cognitoUserSession) => {
            var axi = axios.create({
              baseURL: baseURL,
              withCredentials: false,
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": cognitoUserSession.getIdToken().getJwtToken()
              }
            });
    
            var data = {
                           "memberId":memberId,
                           "partnerName":"Shell",
                           "partner_id":refId,
                           "partnerStatus": "active",
                                "payload":
                                {
                                     "partner_custom_field_A":"", 
                                     "partner_custom_field_B":"", 
                                     "partner_custom_field_C":"", 
                                      "partner_custom_field_D":"", 
                                     "partner_custom_field_E":"", 
                                     "partner_custom_field_F":"", 
                                     "partner_custom_field_G":"", 
                                     "partner_custom_field_H":"", 
                                     "partner_custom_field_I":"", 
                                     "partner_custom_field_J":""
                                }
                }
                axi.post('/partners/update', data).then(function (response) {
                  if (response.data === null || response.status !== 200){
                    // presumed error
                    user_force_refresh();
                    return;
                  } else {
                    user_force_refresh();
                  }
                });
        
    
        });
    }

export default function ToggleDeveloperModeScreen() {
  const navigation = useNavigation();
  const BGimage = require("../../assets/res/blue_bg.png");
  const win = Dimensions.get("window");
  
  const envVars = getEnvVars();

  const [enteredPass, onChangeEmailText] = React.useState("a");

  const devPass = "test123";
  const memberId = useSelector((state) => state.user.user.username);
  const refId = useSelector(
    (state) => state.user.userData.subscriberDetails.referFriendId
  );
  return (
    <View style={GlobalStyles.containerW}>
      <View style={GlobalStyles.backgroundContainer}>
        <Image style={GlobalStyles.backgroundImage} source={BGimage} />
      </View>
      {/* <View style={styles.bodyContainerT}> */}
      <View style={win.width > 768 ? [GlobalStyles.adjustableBodyContainer,{justifyContent: 'center'}] : styles.bodyContainerT }>
          {enteredPass === devPass ? (
              <View style={styles.formContainer}>
              <Text style={styles.TextStyleHeader}>My Account</Text>
              <Text style={styles.TextStyleBody}>
                  Enable / Disable Mode.
              </Text>
              <View style={styles.buttonContainer}>
                  <TouchableOpacity
                  style={styles.SubmitButtonStyleBack}
                  activeOpacity={0.5}
                  // onPress={() => enableDebugMode()}
                  onPress={() => reffererIdToCharityId('Wunan')}
                  >
                  <Text style={styles.TextStyle}>ENABLE</Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                  style={styles.SubmitButtonStyleBack}
                  activeOpacity={0.5}
                  onPress={() => disableDebugMode()}
                  >
                  <Text style={styles.TextStyle}>DISABLE</Text>
                  </TouchableOpacity>
  
                  <TouchableOpacity
                  style={styles.SubmitButtonStyleBack}
                  activeOpacity={0.5}
                  onPress={() => navigation.navigate("MainMenu")}
                  >
                  <Text style={styles.TextStyle}>MAINMENU</Text>
                  </TouchableOpacity>

                  </View>
                <View style={styles.buttonContainer}>
                  <TouchableOpacity
                  style={styles.SubmitButtonStyleBack}
                  activeOpacity={0.5}
                  onPress={() => removeShell(memberId, refId)}
                  >
                  <Text style={styles.TextStyle}>Unlink Shell</Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                  style={styles.SubmitButtonStyleBack}
                  activeOpacity={0.5}
                  onPress={() => reenableShell(memberId, refId)}
                  >
                  <Text style={styles.TextStyle}>Reactive Shell</Text>
                  </TouchableOpacity>
                </View>
                <View style={styles.buttonContainer}>
                  <TouchableOpacity
                  style={styles.SubmitButtonStyleBack}
                  activeOpacity={0.5}
                  onPress={() => removeSavedLogin()}
                  >
                  <Text style={styles.TextStyle}>Reset Saved Login Data</Text>
                  </TouchableOpacity>
                </View>
            </View>
          ) : (
            <View style={styles.inputContainer}>
                  <TextInput
                    style={styles.textInput}
                    placeholder=""
                    placeholderTextColor="#adb4bc"
                    keyboardType={"email-address"}
                    returnKeyType="next"
                    autoCapitalize="none"
                    autoCorrect={false}
                    secureTextEntry={false}
                    value={enteredPass}
                    onChangeText={(text) => onChangeEmailText(text)}
                    dialCodeTextStyle={styles.textInput}
                  />
                </View>
          )}
      </View>
      <View style={GlobalStyles.webFooter}>
        {/* win.width > 768 ? <FooterBarWide /> : null */}
      </View>
    </View>
  );
}

function OptionButton({ icon, label, onPress, subtext, isLastOption }) {
  return (
    <TouchableOpacity
      style={styles.containerBox}
      activeOpacity={0.7}
      onPress={onPress}
    >
      <View style={styles.SubmitButtonStyle}>
        <View style={styles.optionIconContainer}>
          <CustomIcon name={icon} size={24} color="rgba(0,0,0,0.99)" />
        </View>
        <View style={styles.optionTextContainer}>
          <Text style={styles.optionText}>{label}</Text>
        </View>
        <View style={styles.optionSubtextContainer}>
          <Text style={styles.optionSubtext}>{subtext}</Text>
        </View>
      </View>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({

  bodyContainerT: {
    flex: 1,
    paddingTop: 30,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 30,
    justifyContent: 'center',
  },


  formStyle: {
    flexDirection: "column",
    width: "90%",
  },
  inputBox: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 10,
    paddingBottom: 10,
    backgroundColor: "#FFFF",
    marginTop: 8,
    borderRadius: 20,
    justifyContent: "center",
  },

  inputBoxFaded: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 10,
    paddingBottom: 10,
    backgroundColor: "#fee394",
    marginTop: 8,
    borderRadius: 20,
    justifyContent: "center",
  },
  formLabelStyle: {
    color: "#aaaaaa",
    textAlign: "center",
    textAlignVertical: "center",
    fontSize: 15,
    paddingRight: 20,
    paddingTop: 8,
    borderColor: "#CCCCCC",
    fontFamily: "montserrat-medium",
    fontSize: 11,
    textAlign: "left",
    paddingTop: 20,
    paddingBottom: 5,
  },
  bottomContainer: {},

  buttonContainer: {
    flexDirection: "row",
    width: "100%",
    alignContent: "space-between",
    paddingLeft: 10,
    paddingRight: 30,
    paddingTop: 40,
  },

  TextStyle: {
    color: "#000000",
    textAlign: "center",
    fontFamily: "montserrat-medium",
    fontSize: 14,
    lineHeight: 14,
  },
  TextStyleHeader: {
    color: "#ffffff",
    textAlign: "left",
    fontFamily: "montserrat-bold",
    fontSize: 22,
    width: "100%",
    paddingLeft: 30,
    paddingRight: 30,
  },
  TextStyleBody: {
    color: "#000000",
    textAlign: "left",
    fontFamily: "montserrat-regular",
    fontSize: 14,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 20,
    paddingTop: 10,
  },
  formContainer: {
    alignContent: "center",
    backgroundColor: "#FFC72C",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 55,
    borderTopLeftRadius: 70,
    borderTopRightRadius: 70,
    borderBottomRightRadius: 70,
    paddingBottom: 55,
    maxWidth: 800,
    alignSelf: "center",
  },
  SubmitButtonStyle: {
    marginTop: 10,
    paddingTop: 15,
    paddingBottom: 15,
    backgroundColor: "#337599",
    borderRadius: 30,
  },
  SubmitButtonStyleBack: {
    //paddingTop: 20,
    //paddingBottom: 25,
    borderRadius: 50,
    marginLeft: 10,
    backgroundColor: "#FFC72C",
    borderColor: "#000000",
    flex: 1,
    borderWidth: 1,
    color: "#000000",
    height: 60,
    justifyContent: 'center',
  },
  SubmitButtonStyleContinue: {
    //paddingTop: 20,
    //paddingBottom: 25,
    borderRadius: 50,
    marginLeft: 10,
    backgroundColor: "#FFFFFF",
    flex: 1,
    color: "#000000",
    height: 60,
    justifyContent: 'center',
  },
  textInput: {
    ...Platform.select({
      web: {
        outlineStyle: 'none'
      }
    }), 
    borderColor: "#CCCCCC",
    // borderBottomWidth: 1,
    height: 35,
    fontSize: 16,
    paddingRight: 20,
    fontFamily: "montserrat-regular",
    textAlign: "left",
    width: "100%",
  },
  textFaded: {
    //borderColor: "#CCCCCC",
    // borderBottomWidth: 1,
    height: 35,
    fontSize: 16,
    paddingRight: 20,
    paddingTop: 7,
    fontFamily: "montserrat-regular",
    textAlign: "left",
    width: "100%",
    color: "#666666",
  },

  // SubmitButtonStyle: {
  //   flexDirection: "row",
  // },

  optionIconContainer: {
    flex: 2,
    alignSelf: "center",
  },

  optionTextContainer: {
    flex: 6,
    alignSelf: "center",
  },

  optionSubtextContainer: {
    flex: 6,
    alignSelf: "center",
  },

  optionText: {
    color: "#506685",
    fontFamily: "montserrat-bold",
    fontSize: 15,
    textAlign: "left",
  },

  optionSubtext: {
    color: "#000000",
    fontFamily: "montserrat-regular",
    fontSize: 12,
    textAlign: "right",
  },

  containerBox: {
    flex: 1,
    backgroundColor: "#ffffff",
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    paddingTop: 10,
    paddingLeft: 10,
    paddingRight: 10,
    paddingBottom: 10,
    marginBottom: 15,
  },

  containerA: {
    alignItems: "center",
    paddingTop: 20,
    paddingBottom: 20,
  },

  logoText: {
    paddingTop: 20,
  },

  smallLogo: {
    width: 107,
    height: 60,
    resizeMode: "contain",
  },
});
